// Pro intro offer: first month of Pro (monthly) for $1.99, then $6.99/month.
// Eligibility is decided server-side (never subscribed before); the client
// only uses it to choose copy. Checkout applies the coupon itself.
export const PROMO = {
  price: "1.99",
  regularPrice: "6.99",
  headline: "Pro members get 5x the designs.",
  perks: ["5 new designs a month", "15 refinements a month", "Priority support"],
  cta: "Claim $1.99 offer",
  badge: "Exclusive offer",
  fine: "First month, then $6.99/mo. Cancel anytime.",
} as const;

export type UpsellPlacement = "results_limit" | "refine_limit" | "new_design" | "sidebar" | "pricing" | "reminder_paywall" | "hard_wall" | "design_banner" | "render_banner";
